import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import Activity from './modules/activity';
import Auth from './modules/auth';
import Csv from './modules/csv';
import Faq from './modules/faq';
import GeoIP from './modules/geoip';
import Interface from './modules/interface';
import Issuer from './modules/issuer';
import Order from './modules/order';
import Product from './modules/product';
import Template from './modules/template';
import UUID from './modules/uuid';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    getters: {},
    mutations: {},
    modules: {
        auth: Auth,
        interface: Interface,
        template: Template,
        product: Product,
        activity: Activity,
        issuer: Issuer,
        faq: Faq,
        csv: Csv,
        geoIP: GeoIP,
        order: Order,
        uuid: UUID,
    },
    plugins: [createPersistedState({
        key: 'Papyrus',
        paths: [
            'auth',
            'template',
            'product',
            'activity',
            'issuer',
            'csv',
            'geoIP',
            'order',
            'uuid',
            'interface.lastResendEmailTimeStamp',
            'interface.industries',
            'interface.goals',
            'interface.sources',
        ],
    })],
});
